/**
 * Notification Entity Definition
 */
import { z } from "zod";
import { StrapiEntitySchema } from "../schemas/common.schemas";
import { defineEntity } from "./core";
import { getLazyUserEntityDef } from "./lazy-refs";
// Minimal notification schema
const NotificationSchema = StrapiEntitySchema.extend({
    type: z.string().nullish(),
    title: z.string().nullish(),
    message: z.string().nullish(),
    read: z.boolean().nullish(),
});
export const NotificationEntityDef = defineEntity({
    name: "notification",
    schema: NotificationSchema,
    relations: {
        user: { type: "one", entity: getLazyUserEntityDef },
    },
});
